import { consolidationGroupIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";

export const deleteConsolidationGroup = {
  name: "deleteConsolidationGroup" as const,
  input: z.object({ consolidationGroupId: consolidationGroupIdFormat.schema }),
  output: z.object({}),
};
